class Points {
  constructor (ctx, w, h, radius, fillColor, strokeColor, life, speed) {
    this.ctx = ctx;
    this.w = w;
    this.h = h;
    this.radius = radius || 1;
    this.fillColor = fillColor;
    this.strokeColor = strokeColor;
    this.x = Math.random() * w;
    this.y = Math.random() * h;
    this.life = life || 150;
    this.speed = speed || Math.random() * 0.3 + 0.2;
    this.angle = Math.random() * 360;
    this.type = Math.random();
  }

  updateSize (width, height) {
    this.w = width;
    this.h = height;
  }

  show () {
    this.ctx.fillStyle = this.fillColor || '#61B0FD';
    this.ctx.strokeStyle = this.strokeColor || '#61B0FD';
    if (this.type > 0.5) {
      this.ctx.beginPath();
      this.ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);
      this.ctx.closePath();
      this.ctx.stroke();
      this.ctx.fill();
    } else {
      this.ctx.strokeRect(this.x - this.radius * 2, this.y - this.radius * 2, this.radius * 4, this.radius * 4);
    }
  }

  update () {
    this.x = this.x + this.speed * Math.cos(this.angle * Math.PI / 180);
    this.y = this.y + this.speed * Math.sin(this.angle * Math.PI / 180);
    if (this.x < 0) {
      this.x = this.w;
    }
    if (this.x > this.w) {
      this.x = 0;
    }
    if (this.y < 0) {
      this.y = this.h;
    }
    if (this.y > this.h) {
      this.y = 0;
    }
  }
}

export default Points;



// WEBPACK FOOTER //
// ./src/Components/LandingPage/Point.js